import styles from '../../../pages/Badging/SnapshotMonitor/SnapshotMonitor.module.css'

const EventSnapshot = ({ index, eventSnapshot }) => {
    return (
        <>
            <tr className={styles.trEventSnapshots} key={index}>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.client}</td>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.eventName}</td>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.eventId}</td>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.startDate}</td>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.totalRegistered}</td>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.checkedIn ? eventSnapshot.checkedIn : 0}</td>
                <td className={styles.tdEventSnapshots}> {eventSnapshot.adhocPrint ? eventSnapshot.adhocPrint : 0}</td>
            </tr>
        </>
    );
}

export default EventSnapshot;
